<div data-test="aviation-hull-form"
     [formGroup]="form()"
>
  <p-accordion data-test="aviation-hull-accordion"
               [multiple]="true"
               [value]="activePanels()"
               (valueChange)="onActivePanelsChange($event)"
  >
    <p-accordion-panel class="accordion-panel-scroll-target"
                       data-test="general-hull-info-panel"
                       [value]="generalPanel"
    >
      <div #subPanel
           class="accordion-panel-scroll-target"
           [attr.data-index]="nav.getSectionIndex(mainIndex()!)"
      ></div>
      <p-accordion-header data-test="general-hull-info-header">
        <p class="section-title"> General </p>
      </p-accordion-header>
      <p-accordion-content data-test="general-hull-info-content">
        @if (activePanels().includes(generalPanel)) {
          <div class="comparison-grid expanded-mode"
               data-test="general-hull-comparison-grid"
               [formGroup]="form().controls.general"
          >
            <!-- Period Row -->
            <div class="origami-field">
              <albert-period controlName="externalValue"
                             data-test="external-general-period"
                             periodFromGroupName="periodFrom"
                             periodFromInputId="ext_periodFrom"
                             periodFromLabel="Period From"
                             periodToGroupName="periodTo"
                             periodToInputId="ext_periodTo"
                             periodToLabel="Period To"
                             [disabled]="true"
              />
            </div>
            <div class="override-cell">
              <albert-override-wrapper data-test="override-wrapper-general-period"
                                       tooltipLabel="Period"
                                       [disabled]="!canEdit()"
                                       [isVisible]="isFieldVisible('general.periodFrom') || isFieldVisible('general.periodTo')"
                                       (visibilityChange)="toggleField('general.periodFrom'); toggleField('general.periodTo')"
              >
                <albert-period controlName="localValue"
                               data-test="local-general-period"
                               periodFromGroupName="periodFrom"
                               periodFromInputId="loc_periodFrom"
                               periodFromLabel="Period From"
                               periodToGroupName="periodTo"
                               periodToInputId="loc_periodTo"
                               periodToLabel="Period To"
                               [disabled]="!canEdit()"
                />
              </albert-override-wrapper>
            </div>

            <!-- Spares Engine Test Run Row -->
            <div class="origami-field">
              <albert-checkbox
                controlName="externalValue"
                data-test="external-sparesEngineTestRun"
                groupName="sparesEngineTestRun"
                inputId="ext_sparesEngineTestRun"
                label="Spares Engine Test Run"
                [disabled]="true"
              />
            </div>
            <div class="override-cell">
              <div class="flex items-center gap-2">
                <p-checkbox data-test="local-sparesEngineTestRun"
                            inputId="loc_sparesEngineTestRun"
                            [binary]="true"
                            [formControl]="sparesEngineTestRunOverride"
                />
                <label class="font-medium cursor-pointer"
                       for="loc_sparesEngineTestRun"
                >Spares Engine Test Run</label>
              </div>
            </div>

            <!-- Spares Jointly For Row -->
            <div class="origami-field">
            </div>
            <div class="override-cell">
              <albert-checkbox
                controlName="localValue"
                groupName="sparesJointlyFor"
                inputId="loc_sparesJointlyFor"
                label="Spares Jointly For"
                [disabled]="!canEdit()"
              />
            </div>

            @if (isSparesJointlyForChecked()) {
              <!-- Spares Twin Insured Row -->
              <div class="origami-field">
              </div>
              <div class="override-cell">
                <albert-input
                  controlName="localValue"
                  groupName="sparesTwinInsured"
                  inputId="loc_sparesTwinInsured"
                  label="Spares Twin Insured"
                  [disabled]="!canEdit()"
                />
              </div>
            }

            <!-- Hull Deductible Jointly For Row -->
            <div class="origami-field">
            </div>
            <div class="override-cell">
              <albert-checkbox
                controlName="localValue"
                groupName="hullDeductibleJointlyFor"
                inputId="loc_hullDeductibleJointlyFor"
                label="Hull Deductible Jointly For"
                [disabled]="!canEdit()"
              />
            </div>

            @if (isHullDeductibleJointlyForChecked()) {
              <!-- Hull Deductible Twin Insured Row -->
              <div class="origami-field">
              </div>
              <div class="override-cell">
                <albert-input
                  controlName="localValue"
                  groupName="hullDeductibleTwinInsured"
                  inputId="loc_hullDeductibleTwinInsured"
                  label="Hull Deductible Twin Insured"
                  [disabled]="!canEdit()"
                />
              </div>
            }
          </div>
        }
      </p-accordion-content>
    </p-accordion-panel>

    <albert-sub-coverage-panels [activePanels]="activePanels()"
                                [form]="form()"
                                [isCreateMode]="isCreateMode()"
                                [mainIndex]="mainIndex()"
                                [memberExternalId]="memberExternalId()"
                                [panels]="panels"
                                [policyStatus]="policyStatus()"
    />
  </p-accordion>
</div>
